import api from '@pray/shared/utils/api';

export type MarketingCampaignPauseReason = 'payment_issue' | 'asset_delay' | 'other';

export type PauseMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
  pauseReason: MarketingCampaignPauseReason;
  pauseNote?: string;
};

export const pauseMarketingCampaign = async ({
  artistId,
  campaignId,
  pauseReason,
  pauseNote,
}: PauseMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/pause`;

  const body: Record<string, unknown> = {
    pause_reason: pauseReason,
  };

  if (pauseNote) body.pause_note = pauseNote;

  const response = await api.executePostRequest(url, body);

  return response.data;
};
